/* eslint-env browser */
import Domodule from 'domodule';
import Formobj from 'formobj';
import Ajax from 'bequest';
import { addClass, removeClass, fire } from 'domassist';

class Newsletter extends Domodule {
  postInit() {
    this.form = new Formobj(this.el);
  }

  submit(el, event) {
    event.preventDefault();
    const data = this.form.getJSON();
    const path = this.el.action;

    const self = this;
    Ajax.request(path, 'POST', data, (err, resp) => {
      addClass(self.els.fields, 'hide');
      let resultMessage = self.options.thankMessage;

      if (err || resp.statusCode !== 200) {
        resultMessage = self.options.defaultError;
      } else {
        fire(this.el, 'newsletter:subscribe');
      }

      self.els.submitMessage.innerHTML = resultMessage;
      removeClass(self.els.submitMessage, 'hide');
    });
  }
}

Domodule.register('Newsletter', Newsletter);
